// src/pages/ServiceDetailPage.js
/* eslint-disable max-len */

import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Services from '../../data/services';

import slugify from '../../utils/slugify';

export default function ServiceDetailPage() {
  const { slug } = useParams();
  const title = Services.find((s) => slugify(s) === slug);

  return (
      <section className="container mx-auto px-6 py-20">
        {!title ? (
          <div className="text-center">
            <h1 className="text-3xl font-bold text-surface-900">Service not found</h1>
            <p className="mt-4 text-surface-300">We couldn&apos;t find that service.</p>
            <Link to="/services" className="text-brand-green-500 hover:underline mt-4 inline-block font-semibold">Back to services</Link>
          </div>
        ) : (
          <div>
            <h1 className="text-4xl font-extrabold text-surface-900 tracking-tight">{title}</h1>
            <p className="mt-4 text-surface-300 text-lg leading-relaxed">
              This page is a placeholder for <strong className="text-surface-900">{title}</strong>. Add detailed content, images or links here.
            </p>
            <div className="mt-8">
              <Link to="/services" className="text-brand-green-500 hover:underline font-semibold">Back to services</Link>
            </div>
          </div>
        )}
      </section>
  );
}
